import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { navigateTo } from 'gatsby-link';
import logo from '../../../node_modules/boosted/dist/img/orange_logo.svg';
import { userActions } from '../../actions';
import LanguageSwitcher from '../LanguageSwitcher';
import PropTypes from 'prop-types';

class Header extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    event.preventDefault();
    const { dispatch } = this.props;
    dispatch(userActions.logout());
    navigateTo('/signin');
  }

  render() {
    const { t, user, loggedIn } = this.props;

    return (
      <header role="banner">
        <nav className="navbar navbar-dark bg-dark navbar-expand-md">
          <div className="container">
            <a className="navbar-brand" href="/">
              <img src={logo} alt="Back to homepage" title="Back to homepage" />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#collapsing-navbar"
              aria-controls="collapsing-navbar"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>
            <div
              className="navbar-collapse justify-content-between collapse"
              id="collapsing-navbar"
            >
              <ul className="navbar-nav">
                <li className="nav-item">
                  <a className="nav-link" href="/">
                    {t('title')}
                  </a>
                </li>
              </ul>
              <ul className="navbar-nav">
                {loggedIn && (
                  <li className="nav-item dropdown" role="presentation">
                    <a
                      href="#"
                      className="nav-link dropdown-toggle active"
                      data-toggle="dropdown"
                      role="button"
                      aria-haspopup="true"
                    >
                      <span className="icon-avatar" aria-hidden="true">
                        {user && user.firstname}
                      </span>
                    </a>
                    <ul
                      className="dropdown-menu dropdown-menu-right"
                      role="menu"
                    >
                      <li>
                        <a className="dropdown-item" href="/changePassword">
                          {t('passwd')}
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href=""
                          onClick={this.handleClick}
                        >
                          {t('logout')}
                        </a>
                      </li>
                    </ul>
                  </li>
                )}
                {!loggedIn && (
                  <a className="nav-link" href="/signin">
                    {' '}
                    {t('connect')}
                  </a>
                )}
                <LanguageSwitcher />
              </ul>
            </div>
          </div>
        </nav>
      </header>
    );
  }
}

function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  const { loggedIn } = authentication;
  return {
    user,
    loggedIn,
  };
}

Header.propTypes = {
  t: PropTypes.func.isRequired,
  user: PropTypes.object,
  loggedIn: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(translate('Header')(Header));



// WEBPACK FOOTER //
// ./src/components/Header/index.js